import { render, staticRenderFns } from "./IconDocumentTextSolid.vue?vue&type=template&id=1bbf03a0"
import script from "./IconDocumentTextSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentTextSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports